<template>
  <LoadingSpinner
    v-if="isLoading"
    message="جاري تحميل المنتجات..."
    size="lg"
    color="green"
    class="mt-12"
  />

  <div v-else class="min-h-screen bg-gray-50">
    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <!-- Page Header -->
      <div
        class="flex flex-col md:flex-row justify-between items-start md:items-center mb-8"
      >
        <!-- Left side (title + add button) -->
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 space-y-4 sm:space-y-0 w-full md:w-auto"
        >
          <!-- Heading with icon and mobile add button -->
          <div class="flex items-center justify-between w-full sm:w-auto">
            <div class="flex items-center space-x-3">
              <!-- <svg class="h-8 w-8 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7h18M3 12h18M3 17h18" />
        </svg> -->
              <h1 class="text-3xl font-extrabold text-gray-900">
                {{ $t("products.all") }}
              </h1>
            </div>

            <!-- Mobile Add Button (only shows on mobile) -->
            <!-- <button
        @click="handleAddProductClick"
        class="md:hidden inline-flex items-center p-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-semibold rounded-lg shadow-md hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 "
        :aria-label="$t('products.add')"
      >
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
      </button> -->
          </div>

          <!-- Desktop Add Button (hidden on mobile) -->
          <!-- <button
      @click="handleAddProductClick"
      class="hidden md:inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-semibold rounded-lg shadow-md hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 ml-5"
    >
      <svg class="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      {{ $t('products.add') }}
    </button> -->
        </div>

        <!-- Right side (search + mobile filter button) -->
        <div class="flex items-center gap-2 w-full md:w-auto mt-4 md:mt-0">
          <!-- Search Input -->
          <div class="relative flex-1 md:w-64">
            <input
              v-model="searchQuery"
              type="text"
              :placeholder="$t('products.searchPlaceholder')"
              class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-400 absolute right-3 top-2.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>

          <!-- Mobile Filter Button (icon only) - Only shows on mobile -->
          <button
            @click="showMobileSidebar = !showMobileSidebar"
            class="md:hidden p-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors"
            :aria-label="showMobileSidebar ? 'Hide filters' : 'Show filters'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
              />
            </svg>
          </button>
        </div>
      </div>

      <div class="flex flex-col md:flex-row gap-6">
        <!-- Filters Sidebar -->
        <div
          v-show="showMobileSidebar || isDesktop"
          class="w-full md:w-64 flex-shrink-0"
        >
          <div class="w-full md:w-64 flex-shrink-0">
            <div
              class="bg-white p-4 rounded-lg shadow-sm sticky top-24 h-[calc(100vh-8rem)] overflow-y-auto"
            >
              <!-- Categories Filter -->
              <div class="mb-6">
                <h3 class="font-semibold text-gray-800 mb-3">
                  {{ $t("products.filters.categories") }}
                </h3>
                <div class="space-y-2">
                  <div
                    v-for="category in categories"
                    :key="category.id"
                    class="flex items-center gap-2 mt-1"
                  >
                    <input
                      :id="`category-${category.id}`"
                      v-model.number="selectedCategories"
                      type="checkbox"
                      :value="category.id"
                      class="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                    />
                    <label
                      :for="`category-${category.id}`"
                      class="text-sm text-gray-700"
                    >
                      {{ category.name }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Subcategories Filter -->
              <div v-if="subcategories.length > 0" class="mb-6">
                <h3 class="font-semibold text-gray-800 mb-3">
                  {{ $t("products.filters.subcategories") }}
                </h3>
                <div class="space-y-2">
                  <div
                    v-for="sub in subcategories"
                    :key="sub.id"
                    class="flex items-center gap-2 mt-1"
                  >
                    <input
                      :id="`subcategory-${sub.id}`"
                      v-model.number="selectedSubcategories"
                      type="checkbox"
                      :value="sub.id"
                      class="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                    />
                    <label
                      :for="`subcategory-${sub.id}`"
                      class="text-sm text-gray-700"
                    >
                      {{ sub.name }}
                    </label>
                  </div>
                </div>
              </div>
              <!-- States Filter -->
              <div class="mb-6">
                <h3 class="font-semibold text-gray-800 mb-3">
                  {{ $t("products.filters.states") }}
                </h3>
                <div class="space-y-2">
                  <div
                    v-for="state in states"
                    :key="state.id"
                    class="flex items-center gap-2 mt-1"
                  >
                    <input
                      :id="`state-${state.id}`"
                      v-model.number="selectedStates"
                      type="checkbox"
                      :value="state.id"
                      class="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                    />
                    <label
                      :for="`state-${state.id}`"
                      class="text-sm text-gray-700"
                    >
                      {{ state.name }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Areas Filter -->
              <div v-if="areas.length > 0" class="mb-6">
                <h3 class="font-semibold text-gray-800 mb-3">
                  {{ $t("products.filters.areas") }}
                </h3>
                <div class="space-y-2">
                  <div
                    v-for="area in areas"
                    :key="area.id"
                    class="flex items-center gap-2 mt-1"
                  >
                    <input
                      :id="`area-${area.id}`"
                      v-model.number="selectedAreas"
                      type="checkbox"
                      :value="area.id"
                      class="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                    />
                    <label
                      :for="`area-${area.id}`"
                      class="text-sm text-gray-700"
                    >
                      {{ area.name }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Price Filter Slider -->
              <div class="mb-6">
                <h3 class="font-semibold text-gray-800 mb-3">
                  {{ $t("products.filters.priceRange") }}
                </h3>
                <div class="px-2">
                  <div class="flex justify-between text-xs text-gray-500 mb-2">
                    <span>${{ priceFrom }}</span>
                    <span>${{ priceTo }}</span>
                  </div>
                  <div
                    class="relative"
                    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                  >
                    <input
                      type="range"
                      v-model.number="priceFrom"
                      :min="minPrice"
                      :max="maxPrice"
                      @input="validatePriceRange"
                      class="absolute w-full h-2 bg-transparent appearance-none pointer-events-none z-20"
                    />
                    <input
                      type="range"
                      v-model.number="priceTo"
                      :min="minPrice"
                      :max="maxPrice"
                      @input="validatePriceRange"
                      class="absolute w-full h-2 bg-transparent appearance-none pointer-events-none z-10"
                    />
                    <div class="relative h-2 bg-gray-200 rounded-lg z-0">
                      <div
                        class="absolute h-2 rounded-lg bg-teal-500"
                        :style="{
                          left: `${
                            (($i18n.locale === 'ar'
                              ? maxPrice - priceTo
                              : priceFrom - minPrice) /
                              (maxPrice - minPrice)) *
                            100
                          }%`,
                          right: `${
                            (($i18n.locale === 'ar'
                              ? priceFrom - minPrice
                              : maxPrice - priceTo) /
                              (maxPrice - minPrice)) *
                            100
                          }%`,
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="text-xs text-gray-500 mt-2">
                  {{ $t("products.filters.selected") }}: ﷼{{ priceFrom }} - ﷼{{
                    priceTo
                  }}
                </div>
              </div>

              <!-- Reset Filters -->
              <button
                @click="resetFilters"
                class="w-full py-2 px-4 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
              >
                {{ $t("products.filters.reset") }}
              </button>
            </div>
          </div>
        </div>
        <!-- Products Grid -->
        <div class="flex-1">
          <!-- Sorting Options -->
          <div
            class="flex justify-between items-center mb-6 bg-white p-3 rounded-lg shadow-sm"
          >
            <div class="text-sm text-gray-500">
              {{
                $t("products.showing", {
                  count: filteredProducts.length,
                  total: allProducts.length,
                })
              }}
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm text-gray-700"
                >{{ $t("products.sort.label") }}:</label
              >
              <button
                @click="toggleSortOption"
                class="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
                :title="
                  sortOption === 'price-low'
                    ? $t('products.sort.priceLow')
                    : $t('products.sort.priceHigh')
                "
              >
                <svg
                  v-if="sortOption === 'price-low'"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-teal-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 10h10M4 14h6M4 18h2"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-teal-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 18h16M4 14h10M4 10h6M4 6h2"
                  />
                </svg>
              </button>
            </div>
          </div>

          <!-- Products -->
          <div
            v-if="filteredProducts.length > 0"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            <ProductCard
              v-for="product in paginatedProducts"
              :key="product.id"
              :product="product"
              :isInCart="isInCart(product.id)"
              :isInWishlist="isInWishlist(product.id)"
              @add-to-cart="addToCart"
              @toggle-wishlist="toggleWishlist"
              @open-chat="handleChatOpen"
            />
          </div>

          <!-- Empty State -->
          <div v-else class="bg-white rounded-lg p-8 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-12 w-12 mx-auto text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 class="mt-4 text-lg font-medium text-gray-900">
              {{ $t("products.empty.title") }}
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              {{ $t("products.empty.description") }}
            </p>
            <button
              @click="resetFilters"
              class="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
            >
              {{ $t("products.filters.reset") }}
            </button>
          </div>

          <!-- Pagination -->
          <div
            v-if="filteredProducts.length > 0"
            class="mt-8 flex justify-center"
          >
            <nav class="inline-flex rounded-md shadow">
              <button
                @click="currentPage = Math.max(1, currentPage - 1)"
                :disabled="currentPage === 1"
                class="px-3 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
              >
                {{ $t("products.pagination.previous") }}
              </button>
              <button
                v-for="page in visiblePages"
                :key="page"
                @click="currentPage = page"
                :class="[
                  page === currentPage
                    ? 'bg-teal-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50',
                  'px-4 py-2 border-t border-b border-gray-300 text-sm font-medium',
                ]"
              >
                {{ page }}
              </button>
              <button
                @click="currentPage = Math.min(totalPages, currentPage + 1)"
                :disabled="currentPage === totalPages"
                class="px-3 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50"
              >
                {{ $t("products.pagination.next") }}
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DynamicAddModal
    v-if="showAddModal"
    :title="$t('products.addModal.title')"
    :fields="staticFields"
    :initialForm="initialFormData"
    @submit="submitNewProduct"
    @close="showAddModal = false"
  />
</template>

<style scoped>
.sticky-sidebar {
  scroll-behavior: smooth;
}

/* Custom range slider styles */
input[type="range"] {
  -webkit-appearance: none;

  background: transparent;
  pointer-events: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #0d9488;
  cursor: pointer;
  pointer-events: auto;
  margin-top: -2px;
  position: relative;
  z-index: 10;
}
input[type="range"]::-moz-range-thumb {
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background: #0d9488;
  cursor: pointer;
  pointer-events: auto;
}

input[type="range"]::-ms-thumb {
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background: #0d9488;
  cursor: pointer;
  pointer-events: auto;
}
</style>

<script>
import api from "@/api";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { inject } from "vue";
import ProductCard from "@/components/ProductCard.vue";
import DynamicAddModal from "@/components/DynamicAddModal.vue";
import useAuth from "@/composables/useAuth";
import eventBus from "@/eventBus";
// import Swal from "sweetalert2";
export default {
  name: "ProductsPage",
  setup() {
    const cartStore = inject("cartStore");
    const { isAuthenticated } = useAuth();

    return {
      cartStore,
      isAuthenticated,
    };
  },
  components: {
    ProductCard,
    DynamicAddModal,
    LoadingSpinner,
  },
  data() {
    return {
      showMobileSidebar: false,
      isDesktop: window.innerWidth >= 768,
      isLoading: true,
      isSubmitting: false,
      states: [],
      areas: [],
      selectedStates: [],
      selectedAreas: [],
      allProducts: [],
      currencies: [],
      categories: [],
      subcategories: [],
      selectedSubcategories: [],
      searchQuery: "",
      selectedCategories: [],
      priceFrom: 0,
      priceTo: 1000,
      minPrice: 0,
      maxPrice: 1000,
      sortOption: "default",
      currentPage: 1,
      itemsPerPage: 12,
      showAddModal: false,
      staticFields: [
        {
          model: "title",
          label: this.$t("products.addModal.name"),
          type: "text",
          required: true,
        },
        {
          model: "price",
          label: this.$t("products.addModal.price"),
          type: "number",
          required: true,
          priceIcon: true,
        },
        {
          model: "description",
          label: this.$t("products.addModal.description"),
          type: "textarea",
          required: false,
        },
      ],

      dynamicFields: [],
    };
  },
  watch: {
    selectedCategories(newCategories) {
      if (newCategories.length === 1) {
        this.fetchSubcategories(newCategories[0]);
      } else {
        this.subcategories = [];
        this.selectedSubcategories = [];
      }
    },
    selectedStates(newStates) {
      if (newStates.length === 1) {
        this.fetchAreasByState(newStates[0]);
      } else {
        this.areas = [];
        this.selectedAreas = [];
      }
    },
    "$route.query.q"(newQuery) {
      this.searchQuery = newQuery || "";
    },
  },
  computed: {
    filteredProducts() {
      let products = [...this.allProducts];

      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        products = products.filter(
          (p) =>
            p.name.toLowerCase().includes(query) ||
            p.description.toLowerCase().includes(query)
        );
      }

      // Filter by categories
      if (this.selectedCategories.length > 0) {
        products = products.filter(
          (p) =>
            p.category_id !== null &&
            p.category_id !== undefined &&
            this.selectedCategories.includes(Number(p.category_id))
        );
      }

      // Filter by price
      products = products.filter((p) => {
        const finalPrice = parseFloat(
          this.calculateDiscountPrice(p.price, p.discount)
        );
        return finalPrice >= this.priceFrom && finalPrice <= this.priceTo;
      });

      // Filter by subcategories
      if (this.selectedSubcategories.length > 0) {
        products = products.filter((p) =>
          this.selectedSubcategories.includes(Number(p.sub_category_id))
        );
      }

      // Sorting
      switch (this.sortOption) {
        case "price-low":
          products.sort(
            (a, b) =>
              this.calculateDiscountPrice(a.price, a.discount) -
              this.calculateDiscountPrice(b.price, b.discount)
          );
          break;
        case "price-high":
          products.sort(
            (a, b) =>
              this.calculateDiscountPrice(b.price, b.discount) -
              this.calculateDiscountPrice(a.price, a.discount)
          );
          break;
        case "rating":
          products.sort((a, b) => b.rating - a.rating);
          break;
        case "newest":
          products.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          break;
      }
      if (this.selectedStates.length > 0) {
        products = products.filter((p) =>
          this.selectedStates.includes(Number(p.state_id))
        );
      }

      // Filter by areas
      if (this.selectedAreas.length > 0) {
        products = products.filter((p) =>
          this.selectedAreas.includes(Number(p.area_id))
        );
      }

      return products;
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProducts.slice(start, end);
    },
  },
  methods: {
    toggleSortOption() {
      if (this.sortOption === "price-low") {
        this.sortOption = "price-high";
      } else {
        this.sortOption = "price-low";
      }
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 768;
    },
    handleAddProductClick() {
      if (this.isAuthenticated) {
        this.openAddProductModal();
      } else {
        this.$router.push({
          name: "LoginRegisterPage",
          query: { redirect: this.$route.fullPath },
        });
      }
    },
    handleChatOpen(payload) {
      const { userId, product } = payload;
      eventBus.emit("open-chat", { userId, product });
    },
    //   async fetchCurrencies() {
    //   try {
    //     const res = await api.get('/v1/currencies')
    //     this.currencies = res.data

    //     const currencyField = this.staticFields.find(f => f.model === 'currency_id')
    //     if (currencyField) {
    //       currencyField.options = this.currencies.map(c => ({
    //         value: c.id,
    //         label: c.currency_code
    //       }))
    //     }
    //   } catch (error) {
    //     console.error('Failed to load currencies:', error)
    //   }
    // },
    openAddProductModal() {
      this.showAddModal = true;
      // this.fetchCurrencies()
    },

    async submitNewProduct(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await api.post("/v1/items", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          silent: true,
        });
        this.showAddModal = false;
        await this.fetchProducts();
        this.$router.push({ name: "userProfile", query: { tab: "items" } });
      } catch (err) {
        // Just log silently — no popup
        console.error("Failed to save product", err);
        // Optionally: handle only specific errors without popup
        // if (err.response && err.response.status === 429) { ... }
      } finally {
        this.isSubmitting = false;
      }
    },
    async fetchStates() {
      try {
        const res = await api.get("/v1/states");
        this.states = res.data;
      } catch (err) {
        console.error("Failed to load states", err);
      }
    },
    async fetchAreasByState(stateId) {
      try {
        const res = await api.get(`/v1/states/${stateId}/areas`);
        this.areas = res.data;
      } catch (err) {
        console.error("Failed to load areas", err);
      }
    },
    validatePriceRange() {
      if (this.priceFrom > this.priceTo) {
        const temp = this.priceFrom;
        this.priceFrom = this.priceTo;
        this.priceTo = temp;
      }
    },
    async fetchSubcategories(categoryId) {
      try {
        const response = await api.get(
          `/v1/categories/${categoryId}/sub-categories`
        );
        this.subcategories = response.data;
      } catch (error) {
        console.error("Failed to load subcategories:", error);
      }
    },
    async fetchProducts() {
      try {
        const sort = this.$route.query.sort || null;
        const params = {};
        if (sort) {
          params.sort = sort;
        }
        const response = await api.get("/v1/items", { params });
        this.allProducts = response.data.map((item) => ({
          id: item.id,
          name: item.title,
          description: item.description,
          price: parseFloat(item.price),
          images: Array.isArray(item.image)
            ? item.image
            : JSON.parse(item.image),
          discount: item.discount || null,
          rating: 4,
          reviews: item.fields?.length || 0,
          category_id: item.category?.id ?? null,
          sub_category_id: item.sub_category?.id ?? null,
          created_at: item.created_at || new Date().toISOString(),
          user_id: item.user?.id ?? null,
          state_id: item.state?.id ?? null,
          area_id: item.area?.id ?? null,
        }));

        // Calculate price range
        if (this.allProducts.length > 0) {
          const prices = this.allProducts.map((p) =>
            this.calculateDiscountPrice(p.price, p.discount)
          );
          this.minPrice = Math.floor(Math.min(...prices) / 10) * 10;
          this.maxPrice = Math.ceil(Math.max(...prices) / 10) * 10;
          this.priceFrom = this.minPrice;
          this.priceTo = this.maxPrice;
        }
      } catch (error) {
        console.error("Failed to load products:", error);
      }
    },
    async fetchCategories() {
      try {
        const response = await api.get("/v1/categories");
        this.categories = response.data.map((cat) => ({
          id: cat.id,
          name: cat.name,
        }));
      } catch (error) {
        console.error("Failed to load categories:", error);
      }
    },
    calculateDiscountPrice(price, discount) {
      if (!discount) return price;
      return (price * (1 - discount / 100)).toFixed(2);
    },
    resetFilters() {
      this.searchQuery = "";
      this.selectedCategories = [];
      this.selectedSubcategories = [];
      this.subcategories = [];
      this.priceFrom = this.minPrice;
      this.priceTo = this.maxPrice;
      this.sortOption = "default";
      this.currentPage = 1;
      this.selectedStates = [];
      this.selectedAreas = [];
      this.areas = [];
    },
    addToCart(product) {
      this.cartStore.addToCart(product);
    },
    toggleWishlist(productId) {
      this.cartStore.toggleWishlist(productId);
    },
    isInCart(productId) {
      return this.cartStore.isInCart(productId);
    },
    isInWishlist(productId) {
      return this.cartStore.isInWishlist(productId);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.fetchProducts();
    this.fetchStates();
    this.fetchCategories().finally(() => {
      this.isLoading = false;
    });
    const query = this.$route.query.q;
    if (query) {
      this.searchQuery = query;
    }
    const categoryId = this.$route.query.category_id;
    if (categoryId) {
      const parsedId = parseInt(categoryId);
      this.selectedCategories = [parsedId];
      this.fetchSubcategories(parsedId);
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
